import { z } from "zod";

export const CoursePresentationSchema = z.object({
  instructors: z
    .array(
      z.object({
        name: z.string().trim().min(1).max(200),
        headline: z.string().max(200).default(""),
        bio: z.string().max(2000).default(""),
      }),
    )
    .max(10),
  learningObjectives: z.array(z.string().trim().min(1).max(500)).max(30),
  faq: z
    .array(
      z.object({
        question: z.string().trim().min(1).max(300),
        answer: z.string().trim().min(1).max(4000),
      }),
    )
    .max(30),
});
export type CoursePresentation = z.infer<typeof CoursePresentationSchema>;
export const emptyCoursePresentation = (): CoursePresentation => ({
  instructors: [],
  learningObjectives: [],
  faq: [],
});
